import { Component } from '@angular/core';

@Component({
  selector: 'app-create-asin-landing',
  templateUrl: './create-asin-landing.component.html',
  styleUrls: ['./create-asin-landing.component.css']
})
export class CreateAsinLandingComponent {
  typeContainer = 'landing-container'

  screenHeight = window.screen.height - 271; // 1058
  minHeight = 'min-height: ' + this.screenHeight + 'px !important'

  screenHeight2 = window.screen.height - 630; // 428
  minHeight2 = 'min-height: ' + this.screenHeight2 + 'px !important'

  changeContainer(container) {
    this.typeContainer = container
  }


}
